export default __webpack_public_path__ + "static/media/Mouseketeer.d7bb428d.jpg";